// src/features/tidsregistering/hooks/useRegistrations.js
import { useState, useCallback } from 'react';
import { registrationsAPI } from '../services/registrations';
import { useApi } from '../../../hooks/api/useApi';

export function useRegistrations() {
  const [registration, setRegistration] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const clockIn = useCallback(async (data) => {
    const result = await execute(() => registrationsAPI.clockIn(data));
    if (result.success) setRegistration(result.data ?? null);
    return result;
  }, [execute]);

  const clockOut = useCallback(async (registrationId, data) => {
    const result = await execute(() => registrationsAPI.clockOut(registrationId, data));
    if (result.success) setRegistration(result.data ?? null);
    return result;
  }, [execute]);

  const createManual = useCallback(async (data) => {
    const result = await execute(() => registrationsAPI.createManual(data));
    if (result.success) setRegistration(result.data ?? null);
    return result;
  }, [execute]);

  const fetchRegistration = useCallback(async (registrationId) => {
    const result = await execute(() => registrationsAPI.getRegistration(registrationId));
    if (result.success) setRegistration(result.data ?? null);
    return result;
  }, [execute]);

  const fetchForDate = useCallback(async (staffMemberId, date) => {
    const result = await execute(() => registrationsAPI.listForDate(staffMemberId, date));
    if (result.success) setRegistrations(result.data?.registrations ?? []);
    return result;
  }, [execute]);

  const fetchForDepartmentDate = useCallback(async (date) => {
    const result = await execute(() => registrationsAPI.listForDepartmentDate(date));
    if (result.success) setRegistrations(result.data?.registrations ?? []);
    return result;
  }, [execute]);

  const updateRegistration = useCallback(async (registrationId, data) => {
    const result = await execute(() => registrationsAPI.updateRegistration(registrationId, data));
    if (result.success) setRegistration(result.data ?? null);
    return result;
  }, [execute]);

  const deleteRegistration = useCallback(async (registrationId) => {
    const result = await execute(() => registrationsAPI.deleteRegistration(registrationId));
    if (result.success) setRegistration(null);
    return result;
  }, [execute]);

  return {
    registration,
    registrations,
    loading,
    error,
    clearError,
    clockIn,
    clockOut,
    createManual,
    fetchRegistration,
    fetchForDate,
    fetchForDepartmentDate,
    updateRegistration,
    deleteRegistration,
  };
}
